import { Box } from '@/common/components';
import { styled } from '@/stitches.config';
import { ReactComponent as BrokenArrow } from '@assets/icons/broken-arrow.svg';

export const StyledContent = styled(Box, {
  alignItems: 'baseline',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
});

export const StyledPercentage = styled(Box, {
  color: '$darkBlue500',
  fontSize: '$xs',
  fontWeight: '$regular',
  lineHeight: '$4',
  textAlign: 'initial',
});

export const StyledBrokenArrowUpIcon = styled(BrokenArrow, {
  color: '$green300',
  marginBottom: '$3',
});

export const StyledBrokenArrowDownIcon = styled(BrokenArrow, {
  color: '$red400',
  marginBottom: '$3',
  rotate: '180deg',
  transform: 'scalex(-1)',
});
